const DEFAULT_DATA = {
  clients: [],
  employes: [],
  projets: [],
  factures: [],
  devis: [],
  opportunites: [],
  alertes: [],
  notifications: [],
  paies: [],
};

const STORAGE_KEY = 'fhc_store_v2';

export function loadStore() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(DEFAULT_DATA));
      return DEFAULT_DATA;
    }
    return JSON.parse(raw);
  } catch (error) {
    console.error('Erreur lecture store', error);
    return DEFAULT_DATA;
  }
}

export function saveStore(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (error) {
    console.error('Erreur sauvegarde store', error);
  }
}

export function createDefaultStore() {
  return { ...DEFAULT_DATA };
}
